import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef } from 'react';
import MuiFormHelperText from '@material-ui/core/FormHelperText';
import { styled } from '../../../../foundation';
var _StyledFormHelperText = forwardRef(function (_a, ref) {
    var rest = __rest(_a, []);
    return React.createElement(MuiFormHelperText, __assign({}, rest, { ref: ref }));
});
export var StyledFormHelperText = styled(_StyledFormHelperText)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
